import { memo } from "react";
import { Typography, Box, Link } from "@mui/material";

function ProjectLinkBox() {
  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" }, // ✅ works correctly with MUI
        flexDirection: "column",
        alignItems: "center",
        gap: 1.2,
        mt: 1,
      }}
    >
      <Link
        href="./static/documents/PlanBar_2022_paper.pdf"
        target="_blank"
        underline="hover"
      >
        <Typography variant="body2">IT‑Projekt Beispiel</Typography>
      </Link>

      <Link
        href="./static/documents/ER Model KSB-IT.pdf"
        target="_blank"
        underline="hover"
      >
        <Typography variant="body2">Basic ER Model</Typography>
      </Link>
    </Box>
  );
}

export default memo(ProjectLinkBox);
